<!-- filepath: d:\Project\hospital-follow-up-system\ruoyi-ui\src\views\follow_up\ai_group\dataImport.vue -->
<template>
    <div class="app-container">
      <!-- 头部信息栏 -->
      <el-card class="header-card">
        <div class="header-title">
          <h2><i class="el-icon-s-management"></i> AI患者数据导入与管理</h2>
          <div class="header-desc">
            管理肺癌和前列腺癌患者数据，用于AI优化分组和随访方案生成
          </div>
        </div>
        <div class="header-stat">
          <div class="stat-item">
            <div class="stat-number">{{ statistics.total }}</div>
            <div class="stat-label">总数据量</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ statistics.today }}</div>
            <div class="stat-label">今日导入</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ statistics.pending }}</div>
            <div class="stat-label">待审核</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ statistics.error }}
              <span v-if="statistics.error > 0" class="stat-alert">
                <i class="el-icon-warning-outline"></i>
              </span>
            </div>
            <div class="stat-label">异常数据</div>
          </div>
        </div>
      </el-card>
  
      <!-- 数据导入区域 -->
      <el-card class="import-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-upload2"></i> 数据导入</span>
          <el-tooltip content="数据导入指南" placement="top">
            <el-button style="float: right; padding: 3px 0" type="text" @click="showHelp = true">
              <i class="el-icon-question"></i> 导入帮助
            </el-button>
          </el-tooltip>
        </div>
  
        <el-tabs v-model="importMethod" type="border-card">
          <!-- HIS系统导入 -->
          <el-tab-pane label="从HIS系统导入" name="his">
            <div class="his-import-container">
              <el-form :model="hisForm" label-width="120px" size="small">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="疾病类型">
                      <el-select v-model="hisForm.diseaseType" placeholder="请选择疾病类型" style="width: 100%">
                        <el-option label="肺癌" value="lung"></el-option>
                        <el-option label="前列腺癌" value="prostate"></el-option>
                        <el-option label="全部" value="all"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="数据时间范围">
                      <el-date-picker
                        v-model="hisForm.dateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="width: 100%">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="科室">
                      <el-select v-model="hisForm.department" placeholder="请选择科室" style="width: 100%">
                        <el-option label="肿瘤科" value="oncology"></el-option>
                        <el-option label="胸外科" value="thoracic"></el-option>
                        <el-option label="泌尿外科" value="urology"></el-option>
                        <el-option label="全部" value="all"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
  
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="数据类型">
                      <el-checkbox-group v-model="hisForm.dataTypes">
                        <el-checkbox label="patient">患者基本信息</el-checkbox>
                        <el-checkbox label="lab">检验检查数据</el-checkbox>
                        <el-checkbox label="treatment">治疗记录</el-checkbox>
                        <el-checkbox label="followup">随访记录</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="数据优先级">
                      <el-radio-group v-model="hisForm.priority">
                        <el-radio label="high">高优先级</el-radio>
                        <el-radio label="normal">普通优先级</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="自动审核">
                      <el-switch
                        v-model="hisForm.autoAudit"
                        active-text="启用"
                        inactive-text="禁用">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
  
                <el-form-item>
                  <el-button type="primary" :loading="loading.his" @click="importFromHIS">开始从HIS导入</el-button>
                  <el-button @click="resetHisForm">重置</el-button>
                </el-form-item>
              </el-form>
  
              <!-- HIS连接状态 -->
              <el-alert
                v-if="hisStatus.connected"
                title="HIS系统连接正常"
                type="success"
                show-icon
                :closable="false">
                上次同步时间: {{ hisStatus.lastSync }}
              </el-alert>
              <el-alert
                v-else
                title="HIS系统连接异常，请检查网络或联系系统管理员"
                type="error"
                show-icon
                :closable="false">
              </el-alert>
            </div>
          </el-tab-pane>
  
          <!-- 手动上传 -->
          <el-tab-pane label="手动上传数据" name="manual">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="upload-container">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-change="handleFileChange"
                    :file-list="fileList"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">支持上传Excel、CSV、JSON格式文件，单个文件不超过10MB</div>
                  </el-upload>
                </div>
                <div class="upload-actions">
                  <el-button type="primary" :disabled="fileList.length === 0" @click="uploadFiles" :loading="loading.upload">开始上传</el-button>
                  <el-button @click="fileList = []">清空</el-button>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="upload-template">
                  <h4><i class="el-icon-document"></i> 数据模板下载</h4>
                  <p>请下载对应模板，按格式填写数据后上传</p>
                  <div class="template-list">
                    <div class="template-item">
                      <div class="template-icon"><i class="el-icon-document-copy"></i></div>
                      <div class="template-info">
                        <div class="template-name">肺癌患者数据模板</div>
                        <div class="template-desc">包含患者基本信息、检查结果、治疗记录等</div>
                      </div>
                      <el-button type="text" icon="el-icon-download">下载</el-button>
                    </div>
                    <div class="template-item">
                      <div class="template-icon"><i class="el-icon-document-copy"></i></div>
                      <div class="template-info">
                        <div class="template-name">前列腺癌患者数据模板</div>
                        <div class="template-desc">包含患者基本信息、检查结果、治疗记录等</div>
                      </div>
                      <el-button type="text" icon="el-icon-download">下载</el-button>
                    </div>
                    <div class="template-item">
                      <div class="template-icon"><i class="el-icon-document-copy"></i></div>
                      <div class="template-info">
                        <div class="template-name">随访记录导入模板</div>
                        <div class="template-desc">适用于批量导入历史随访记录</div>
                      </div>
                      <el-button type="text" icon="el-icon-download">下载</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-card>
  
      <!-- 数据状态卡片 -->
      <el-row :gutter="20" class="status-cards">
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="status-card">
            <div class="status-icon" style="background-color: #409EFF">
              <i class="el-icon-document"></i>
            </div>
            <div class="status-info">
              <div class="status-title">总患者数据</div>
              <div class="status-value">{{ patientData.total }}</div>
              <div class="status-desc">
                <span>肺癌: {{ patientData.lung }}</span>
                <span>前列腺癌: {{ patientData.prostate }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="status-card">
            <div class="status-icon" style="background-color: #67C23A">
              <i class="el-icon-finished"></i>
            </div>
            <div class="status-info">
              <div class="status-title">可用于AI分析</div>
              <div class="status-value">{{ patientData.valid }}</div>
              <div class="status-desc">
                <span>数据完整率: {{ patientData.completionRate }}%</span>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="status-card">
            <div class="status-icon" style="background-color: #E6A23C">
              <i class="el-icon-warning"></i>
            </div>
            <div class="status-info">
              <div class="status-title">数据缺失</div>
              <div class="status-value">{{ patientData.incomplete }}</div>
              <div class="status-desc">
                <span>需数据补充: {{ patientData.needSupply }} 条</span>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="status-card">
            <div class="status-icon" style="background-color: #F56C6C">
              <i class="el-icon-close"></i>
            </div>
            <div class="status-info">
              <div class="status-title">数据异常</div>
              <div class="status-value">{{ patientData.error }}</div>
              <div class="status-desc">
                <el-button type="text" size="small" @click="handleViewErrors">查看异常详情</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 导入历史与进度 -->
      <el-card class="import-history-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-time"></i> 导入历史与进度</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="refreshImportHistory">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
        </div>
  
        <el-table :data="importHistory" style="width: 100%" v-loading="loading.history">
          <el-table-column prop="id" label="任务ID" width="100"></el-table-column>
          <el-table-column prop="importType" label="导入类型" width="120">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.importType === 'HIS' ? 'primary' : 'success'">
                {{ scope.row.importType }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="diseaseType" label="疾病类型" width="120">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.diseaseType === 'lung' ? 'danger' : 'warning'">
                {{ scope.row.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="dataCount" label="数据量" width="100"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="180"></el-table-column>
          <el-table-column prop="status" label="状态" width="120">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">{{ getStatusText(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="progress" label="进度" width="200">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.progress" :status="getProgressStatus(scope.row.status)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="errorRate" label="异常率" width="120">
            <template slot-scope="scope">
              <span :class="{'error-rate': scope.row.errorRate > 5}">{{ scope.row.errorRate }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button 
                size="mini" 
                type="primary" 
                icon="el-icon-view" 
                @click="viewImportDetail(scope.row)">详情</el-button>
              <el-button 
                size="mini" 
                type="danger" 
                icon="el-icon-delete" 
                @click="deleteImport(scope.row)"
                :disabled="scope.row.status === 'processing'">删除</el-button>
              <el-button 
                v-if="scope.row.status === 'failed' || scope.row.status === 'partial'" 
                size="mini" 
                type="warning" 
                icon="el-icon-refresh-right" 
                @click="retryImport(scope.row)">重试</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </el-card>
  
      <!-- 数据管理表格 -->
      <el-card class="data-management-card">
        <div slot="header" class="clearfix">
          <span><i class="el-icon-s-data"></i> 数据管理</span>
          <div class="header-operations">
            <el-input
              placeholder="搜索患者姓名/ID"
              v-model="search"
              style="width: 200px; margin-right: 10px"
              clearable
              prefix-icon="el-icon-search">
            </el-input>
            <el-select v-model="filterStatus" placeholder="数据状态" style="width: 120px; margin-right: 10px" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="有效" value="valid"></el-option>
              <el-option label="缺失" value="missing"></el-option>
              <el-option label="异常" value="error"></el-option>
              <el-option label="待分析" value="pending"></el-option>
              <el-option label="已分析" value="analyzed"></el-option>
            </el-select>
            <el-select v-model="filterDisease" placeholder="疾病类型" style="width: 120px; margin-right: 10px" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="肺癌" value="lung"></el-option>
              <el-option label="前列腺癌" value="prostate"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="searchData">搜索</el-button>
            <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
  
        <el-tabs v-model="dataTab">
          <el-tab-pane label="患者数据" name="patient">
            <el-table 
              :data="patientList" 
              style="width: 100%" 
              border 
              v-loading="loading.table"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="id" label="患者ID" width="100" sortable></el-table-column>
              <el-table-column prop="name" label="患者姓名" width="100">
                <template slot-scope="scope">
                  <el-tooltip :content="'身份证: ' + scope.row.idNumber" placement="top">
                    <span>{{ scope.row.name }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" width="80" sortable></el-table-column>
              <el-table-column prop="gender" label="性别" width="80">
                <template slot-scope="scope">
                  {{ scope.row.gender === 'male' ? '男' : '女' }}
                </template>
              </el-table-column>
              <el-table-column prop="diseaseType" label="疾病类型" width="100">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.diseaseType === 'lung' ? 'danger' : 'warning'" size="small">
                    {{ scope.row.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="stage" label="分期" width="100"></el-table-column>
              <el-table-column prop="diagnosisDate" label="确诊日期" width="120" sortable></el-table-column>
              <el-table-column prop="dataStatus" label="数据状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getDataStatusType(scope.row.dataStatus)" size="small">
                    {{ getDataStatusText(scope.row.dataStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="dataCompleteness" label="数据完整度" width="150">
                <template slot-scope="scope">
                  <el-progress 
                    :percentage="scope.row.dataCompleteness"
                    :color="getCompletenessColor(scope.row.dataCompleteness)">
                  </el-progress>
                </template>
              </el-table-column>
              <el-table-column prop="aiStatus" label="AI分析" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getAiStatusType(scope.row.aiStatus)" size="small">
                    {{ getAiStatusText(scope.row.aiStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="lastUpdate" label="更新时间" width="180"></el-table-column>
              <el-table-column fixed="right" label="操作" width="260">
                <template slot-scope="scope">
                  <el-button 
                    size="mini" 
                    type="primary" 
                    @click="viewPatientDetail(scope.row)"
                    icon="el-icon-view">查看</el-button>
                  <el-button 
                    size="mini" 
                    type="success" 
                    @click="editPatientData(scope.row)"
                    icon="el-icon-edit">编辑</el-button>
                  <el-button 
                    size="mini" 
                    type="warning" 
                    @click="analyzePatient(scope.row)"
                    :disabled="scope.row.dataStatus !== 'valid' || scope.row.aiStatus === 'analyzed'"
                    icon="el-icon-s-operation">分析</el-button>
                </template>
              </el-table-column>
            </el-table>
  
            <div class="table-operations">
              <el-button type="primary" :disabled="selection.length === 0" @click="batchAnalyze">批量分析</el-button>
              <el-button type="danger" :disabled="selection.length === 0" @click="batchDelete">批量删除</el-button>
              <el-button type="warning" :disabled="selection.length === 0" @click="batchExport">导出数据</el-button>
            </div>
  
            <div class="pagination-container">
              <el-pagination
                @size-change="handleDataSizeChange"
                @current-change="handleDataCurrentChange"
                :current-page="dataPagination.currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="dataPagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataPagination.total">
              </el-pagination>
            </div>
          </el-tab-pane>
  
          <el-tab-pane label="数据质量" name="quality">
            <el-table :data="dataQualityList" style="width: 100%" border v-loading="loading.quality">
              <el-table-column prop="patientId" label="患者ID" width="100"></el-table-column>
              <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
              <el-table-column prop="diseaseType" label="疾病类型" width="100">
                <template slot-scope="scope">
                  <el-tag size="small" :type="scope.row.diseaseType === 'lung' ? 'danger' : 'warning'">
                    {{ scope.row.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="issueType" label="问题类型" width="120">
                <template slot-scope="scope">
                  <el-tag size="small" :type="getIssueTypeTag(scope.row.issueType)">
                    {{ scope.row.issueType }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="issueField" label="问题字段" width="150"></el-table-column>
              <el-table-column prop="issueDescription" label="问题描述" min-width="200"></el-table-column>
              <el-table-column prop="suggestion" label="修复建议" min-width="200"></el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag size="small" :type="scope.row.status === 'fixed' ? 'success' : 'info'">
                    {{ scope.row.status === 'fixed' ? '已修复' : '待修复' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button 
                    size="mini" 
                    type="primary" 
                    @click="fixIssue(scope.row)"
                    :disabled="scope.row.status === 'fixed'"
                    icon="el-icon-edit">修复</el-button>
                  <el-button 
                    size="mini" 
                    type="success" 
                    @click="skipIssue(scope.row)"
                    :disabled="scope.row.status === 'fixed'"
                    icon="el-icon-check">忽略</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <div class="pagination-container">
              <el-pagination
                @size-change="handleQualitySizeChange"
                @current-change="handleQualityCurrentChange"
                :current-page="qualityPagination.currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="qualityPagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="qualityPagination.total">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
  
      <!-- 数据修复对话框 -->
      <el-dialog title="数据修复" :visible.sync="fixDialog.visible" width="50%">
        <div v-if="fixDialog.issue">
          <div class="issue-info">
            <h4>问题详情</h4>
            <el-descriptions border :column="1">
              <el-descriptions-item label="患者ID">{{ fixDialog.issue.patientId }}</el-descriptions-item>
              <el-descriptions-item label="患者姓名">{{ fixDialog.issue.patientName }}</el-descriptions-item>
              <el-descriptions-item label="问题字段">{{ fixDialog.issue.issueField }}</el-descriptions-item>
              <el-descriptions-item label="问题描述">{{ fixDialog.issue.issueDescription }}</el-descriptions-item>
              <el-descriptions-item label="修复建议">{{ fixDialog.issue.suggestion }}</el-descriptions-item>
            </el-descriptions>
          </div>
  
          <div class="fix-form">
            <h4>数据修复</h4>
            <el-form :model="fixDialog.form" label-width="120px">
              <el-form-item :label="fixDialog.issue.issueField">
                <el-input v-model="fixDialog.form.value"></el-input>
              </el-form-item>
              <el-form-item label="修复说明">
                <el-input type="textarea" v-model="fixDialog.form.comment" :rows="3"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="fixDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="submitFix" :loading="loading.fix">确认修复</el-button>
        </span>
      </el-dialog>
  
      <!-- 患者详情对话框 -->
      <el-dialog title="患者详情" :visible.sync="patientDetailDialog.visible" width="70%">
        <div v-if="patientDetailDialog.patient" class="patient-detail-container">
          <el-tabs v-model="patientDetailDialog.activeTab">
            <el-tab-pane label="基本信息" name="basic">
              <el-descriptions title="患者基本信息" border :column="2">
                <el-descriptions-item label="患者ID">{{ patientDetailDialog.patient.id }}</el-descriptions-item>
                <el-descriptions-item label="患者姓名">{{ patientDetailDialog.patient.name }}</el-descriptions-item>
                <el-descriptions-item label="年龄">{{ patientDetailDialog.patient.age }}</el-descriptions-item>
                <el-descriptions-item label="性别">{{ patientDetailDialog.patient.gender === 'male' ? '男' : '女' }}</el-descriptions-item>
                <el-descriptions-item label="身份证号">{{ patientDetailDialog.patient.idNumber }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{ patientDetailDialog.patient.phone }}</el-descriptions-item>
                <el-descriptions-item label="疾病类型">
                  {{ patientDetailDialog.patient.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
                </el-descriptions-item>
                <el-descriptions-item label="疾病分期">{{ patientDetailDialog.patient.stage }}</el-descriptions-item>
                <el-descriptions-item label="确诊日期">{{ patientDetailDialog.patient.diagnosisDate }}</el-descriptions-item>
                <el-descriptions-item label="主治医生">{{ patientDetailDialog.patient.doctor }}</el-descriptions-item>
                <el-descriptions-item label="数据完整度">
                  <el-progress 
                    :percentage="patientDetailDialog.patient.dataCompleteness"
                    :color="getCompletenessColor(patientDetailDialog.patient.dataCompleteness)">
                  </el-progress>
                </el-descriptions-item>
                <el-descriptions-item label="数据状态">
                  <el-tag :type="getDataStatusType(patientDetailDialog.patient.dataStatus)">
                    {{ getDataStatusText(patientDetailDialog.patient.dataStatus) }}
                  </el-tag>
                </el-descriptions-item>
              </el-descriptions>
            </el-tab-pane>
            
            <el-tab-pane label="临床检查" name="clinical">
              <el-table :data="patientDetailDialog.clinicalTests" style="width: 100%" border>
                <el-table-column prop="testDate" label="检查日期" width="120"></el-table-column>
                <el-table-column prop="testType" label="检查类型" width="150"></el-table-column>
                <el-table-column prop="testName" label="检查名称" width="200"></el-table-column>
                <el-table-column prop="result" label="检查结果" min-width="250"></el-table-column>
                <el-table-column prop="conclusion" label="结论" min-width="250"></el-table-column>
              </el-table>
            </el-tab-pane>
            
            <el-tab-pane label="治疗记录" name="treatment">
              <el-table :data="patientDetailDialog.treatments" style="width: 100%" border>
                <el-table-column prop="treatmentDate" label="治疗日期" width="120"></el-table-column>
                <el-table-column prop="treatmentType" label="治疗类型" width="150"></el-table-column>
                <el-table-column prop="treatmentName" label="治疗名称" width="200"></el-table-column>
                <el-table-column prop="doctor" label="治疗医生" width="100"></el-table-column>
                <el-table-column prop="details" label="治疗详情" min-width="300"></el-table-column>
                <el-table-column prop="response" label="治疗响应" width="120"></el-table-column>
                <el-table-column prop="sideEffects" label="副作用" min-width="200"></el-table-column>
              </el-table>
            </el-tab-pane>
            
            <el-tab-pane label="随访记录" name="followup">
              <el-table :data="patientDetailDialog.followups" style="width: 100%" border>
                <el-table-column prop="followupDate" label="随访日期" width="120"></el-table-column>
                <el-table-column prop="followupType" label="随访方式" width="100"></el-table-column>
                <el-table-column prop="attendingDoctor" label="随访医生" width="100"></el-table-column>
                <el-table-column prop="symptoms" label="主诉症状" min-width="200"></el-table-column>
                <el-table-column prop="physicalExam" label="体检结果" min-width="200"></el-table-column>
                <el-table-column prop="assessment" label="评估结果" min-width="200"></el-table-column>
                <el-table-column prop="plan" label="后续计划" min-width="200"></el-table-column>
              </el-table>
            </el-tab-pane>
            
            <el-tab-pane label="数据质量" name="quality">
              <div v-if="patientDetailDialog.dataIssues.length > 0">
                <el-table :data="patientDetailDialog.dataIssues" style="width: 100%" border>
                  <el-table-column prop="issueType" label="问题类型" width="120">
                    <template slot-scope="scope">
                      <el-tag size="small" :type="getIssueTypeTag(scope.row.issueType)">
                        {{ scope.row.issueType }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="issueField" label="问题字段" width="150"></el-table-column>
                  <el-table-column prop="issueDescription" label="问题描述" min-width="200"></el-table-column>
                  <el-table-column prop="suggestion" label="修复建议" min-width="200"></el-table-column>
                  <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                      <el-tag size="small" :type="scope.row.status === 'fixed' ? 'success' : 'info'">
                        {{ scope.row.status === 'fixed' ? '已修复' : '待修复' }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button 
                        size="mini" 
                        type="primary" 
                        @click="fixIssue(scope.row)"
                        :disabled="scope.row.status === 'fixed'"
                        icon="el-icon-edit">修复</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-empty v-else description="数据质量良好，无异常问题"></el-empty>
            </el-tab-pane>
          </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="patientDetailDialog.visible = false">关闭</el-button>
          <el-button 
            type="primary" 
            @click="editPatientData(patientDetailDialog.patient)"
            v-if="patientDetailDialog.patient">编辑数据</el-button>
          <el-button 
            type="success" 
            @click="analyzePatient(patientDetailDialog.patient)"
            v-if="patientDetailDialog.patient && patientDetailDialog.patient.dataStatus === 'valid' && patientDetailDialog.patient.aiStatus !== 'analyzed'">
            进行分析</el-button>
        </span>
      </el-dialog>
  
      <!-- 导入详情对话框 -->
      <el-dialog title="导入任务详情" :visible.sync="importDetailDialog.visible" width="70%">
        <div v-if="importDetailDialog.import" class="import-detail-container">
          <el-descriptions title="基本信息" border :column="2">
            <el-descriptions-item label="任务ID">{{ importDetailDialog.import.id }}</el-descriptions-item>
            <el-descriptions-item label="导入类型">{{ importDetailDialog.import.importType }}</el-descriptions-item>
            <el-descriptions-item label="疾病类型">
              {{ importDetailDialog.import.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
            </el-descriptions-item>
            <el-descriptions-item label="数据量">{{ importDetailDialog.import.dataCount }}</el-descriptions-item>
            <el-descriptions-item label="开始时间">{{ importDetailDialog.import.startTime }}</el-descriptions-item>
            <el-descriptions-item label="完成时间">{{ importDetailDialog.import.endTime || '-' }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag :type="getStatusType(importDetailDialog.import.status)">
                {{ getStatusText(importDetailDialog.import.status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="进度">
              <el-progress 
                :percentage="importDetailDialog.import.progress" 
                :status="getProgressStatus(importDetailDialog.import.status)">
              </el-progress>
            </el-descriptions-item>
          </el-descriptions>
  
          <h4 style="margin-top: 20px">导入内容统计</h4>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-card shadow="hover" class="stat-mini-card">
                <div class="stat-mini-title">成功导入</div>
                <div class="stat-mini-value">{{ importDetailDialog.stats.success }}</div>
                <div class="stat-mini-desc">
                  {{ ((importDetailDialog.stats.success / importDetailDialog.import.dataCount) * 100).toFixed(1) }}%
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="stat-mini-card">
                <div class="stat-mini-title">数据异常</div>
                <div class="stat-mini-value">{{ importDetailDialog.stats.error }}</div>
                <div class="stat-mini-desc">
                  {{ importDetailDialog.import.errorRate }}%
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card shadow="hover" class="stat-mini-card">
                <div class="stat-mini-title">完整数据</div>
                <div class="stat-mini-value">{{ importDetailDialog.stats.complete }}</div>
                <div class="stat-mini-desc">
                  可直接用于AI分析
                </div>
              </el-card>
            </el-col>
          </el-row>
  
          <h4 style="margin-top: 20px">详细日志</h4>
          <el-table :data="importDetailDialog.logs" style="width: 100%" border>
            <el-table-column prop="time" label="时间" width="180"></el-table-column>
            <el-table-column prop="level" label="级别" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="getLogLevelType(scope.row.level)">
                  {{ scope.row.level }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="信息" min-width="300"></el-table-column>
            <el-table-column prop="details" label="详情" min-width="300">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.details" @click="showLogDetails(scope.row)">
                  查看详情
                </el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDetailDialog.visible = false">关闭</el-button>
          <el-button 
            type="primary" 
            icon="el-icon-download"
            @click="downloadImportLog">下载日志</el-button>
          <el-button 
            type="warning" 
            icon="el-icon-refresh-right"
            @click="retryImport(importDetailDialog.import)"
            v-if="importDetailDialog.import && (importDetailDialog.import.status === 'failed' || importDetailDialog.import.status === 'partial')">
            重试导入</el-button>
        </span>
      </el-dialog>
  
      <!-- 帮助对话框 -->
      <el-dialog title="数据导入帮助" :visible.sync="showHelp" width="60%">
        <div class="help-content">
          <h3>如何导入患者数据?</h3>
          <p>系统提供两种方式导入患者数据：</p>
          <ol>
            <li>
              <strong>从HIS系统导入:</strong> 
              <p>系统会自动连接医院HIS系统，拉取符合条件的患者数据，包括患者基本信息、诊断记录、检验检查结果、治疗记录和随访记录等。</p>
              <p>使用此方式可以设置疾病类型、日期范围和科室等筛选条件。</p>
            </li>
            <li>
              <strong>手动上传数据:</strong>
              <p>系统支持Excel、CSV、JSON等格式的数据文件上传，请先下载对应疾病类型的模板，按要求填写后上传。</p>
              <p>系统会自动校验上传文件格式和内容，确保数据可以正确导入。</p>
            </li>
          </ol>
  
          <h3>导入数据格式要求</h3>
          <ul>
            <li>患者基本信息必须包含：姓名、年龄、性别、身份证号、诊断信息等</li>
            <li>临床检查数据需包含：检查日期、检查类型、检查结果等</li>
            <li>治疗记录需包含：治疗日期、治疗类型、药物信息、剂量、疗效评估等</li>
            <li>随访记录需包含：随访日期、随访方式、症状记录、医生评估等</li>
          </ul>
  
          <h3>数据问题类型说明</h3>
          <el-table :data="helpData.issueTypes" style="width: 100%" border>
            <el-table-column prop="type" label="问题类型" width="150"></el-table-column>
            <el-table-column prop="description" label="说明"></el-table-column>
            <el-table-column prop="solution" label="解决方法"></el-table-column>
          </el-table>
  
          <h3>常见问题</h3>
          <el-collapse accordion>
            <el-collapse-item title="1. 为什么有些数据无法用于AI分析?" name="1">
              <p>AI分析需要完整的患者数据，包括基本信息、疾病诊断、检查结果和治疗记录等。如果关键数据缺失或有明显异常，系统会标记为"不可用于AI分析"。</p>
              <p>您可以在数据质量页面查看具体问题，并进行数据修复或补充。</p>
            </el-collapse-item>
            <el-collapse-item title="2. 导入过程中断该怎么办?" name="2">
              <p>系统会自动保存已成功导入的数据，您可以在导入历史中找到中断的任务，点击"重试"按钮继续导入。</p>
            </el-collapse-item>
            <el-collapse-item title="3. 数据格式不一致怎么处理?" name="3">
              <p>系统会自动尝试规范化处理一些常见的格式不一致问题，但对于复杂情况，您可能需要手动修复。在数据质量页面，系统会提供详细的问题描述和修复建议。</p>
            </el-collapse-item>
            <el-collapse-item title="4. HIS系统连接异常怎么办?" name="4">
              <p>请检查网络连接，确认HIS系统是否正常运行。如果问题持续存在，请联系IT支持人员检查系统接口配置。</p>
            </el-collapse-item>
          </el-collapse>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="showHelp = false">我知道了</el-button>
        </span>
      </el-dialog>
  
      <!-- 日志详情对话框 -->
      <el-dialog title="日志详情" :visible.sync="logDetailDialog.visible" width="50%">
        <div v-if="logDetailDialog.log" class="log-detail">
          <pre>{{ JSON.stringify(logDetailDialog.log.details, null, 2) }}</pre>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="logDetailDialog.visible = false">关闭</el-button>
        </span>
      </el-dialog>
  
      <!-- 查看错误对话框 -->
      <el-dialog title="数据异常列表" :visible.sync="errorDialog.visible" width="80%">
        <el-table :data="errorDialog.data" style="width: 100%" border>
          <el-table-column prop="patientId" label="患者ID" width="100"></el-table-column>
          <el-table-column prop="patientName" label="患者姓名" width="100"></el-table-column>
          <el-table-column prop="diseaseType" label="疾病类型" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.diseaseType === 'lung' ? 'danger' : 'warning'">
                {{ scope.row.diseaseType === 'lung' ? '肺癌' : '前列腺癌' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errorType" label="错误类型" width="120">
            <template slot-scope="scope">
              <el-tag size="small" type="danger">{{ scope.row.errorType }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errorField" label="错误字段" width="120"></el-table-column>
          <el-table-column prop="errorValue" label="错误值" width="150"></el-table-column>
          <el-table-column prop="errorDescription" label="错误描述" min-width="200"></el-table-column>
          <el-table-column prop="suggestion" label="修正建议" min-width="200"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="fixError(scope.row)" icon="el-icon-edit">修复</el-button>
              <el-button size="mini" type="danger" @click="ignoreError(scope.row)" icon="el-icon-delete">忽略</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="handleErrorSizeChange"
            @current-change="handleErrorCurrentChange"
            :current-page="errorDialog.pagination.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="errorDialog.pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="errorDialog.pagination.total">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="errorDialog.visible = false">关闭</el-button>
          <el-button type="primary" @click="batchFixErrors">批量修复</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "DataImport",
    data() {
      return {
        // 导入方式
        importMethod: "his",
  
        // HIS导入表单
        hisForm: {
          diseaseType: "all",
          dateRange: null,
          department: "all",
          dataTypes: ["patient", "lab", "treatment", "followup"],
          priority: "normal",
          autoAudit: true
        },
  
        // HIS系统状态
        hisStatus: {
          connected: true,
          lastSync: "2024-05-10 15:30:45"
        },
  
        // 文件列表
        fileList: [],
  
        // 搜索和筛选
        search: "",
        filterStatus: "",
        filterDisease: "",
  
        // 数据标签页
        dataTab: "patient",
  
        // 统计数据
        statistics: {
          total: 1286,
          today: 32,
          pending: 15,
          error: 8
        },
  
        // 患者数据统计
        patientData: {
          total: 1286,
          lung: 738,
          prostate: 548,
          valid: 1032,
          incomplete: 246,
          error: 8,
          needSupply: 56,
          completionRate: 80
        },
  
        // 分页数据
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 23
        },
  
        dataPagination: {
          currentPage: 1,
          pageSize: 10,
          total: 1286
        },
  
        qualityPagination: {
          currentPage: 1,
          pageSize: 10,
          total: 162
        },
  
        // 选中的记录
        selection: [],
  
        // 帮助对话框
        showHelp: false,
  
        // 数据修复对话框
        fixDialog: {
          visible: false,
          issue: null,
          form: {
            value: "",
            comment: ""
          }
        },
  
        // 患者详情对话框
        patientDetailDialog: {
          visible: false,
          patient: null,
          activeTab: "basic",
          clinicalTests: [],
          treatments: [],
          followups: [],
          dataIssues: []
        },
  
        // 导入详情对话框
        importDetailDialog: {
          visible: false,
          import: null,
          stats: {
            success: 0,
            error: 0,
            complete: 0
          },
          logs: []
        },
  
        // 日志详情对话框
        logDetailDialog: {
          visible: false,
          log: null
        },
  
        // 错误查看对话框
        errorDialog: {
          visible: false,
          data: [],
          pagination: {
            currentPage: 1,
            pageSize: 10,
            total: 0
          }
        },
  
        // 加载状态
        loading: {
          his: false,
          upload: false,
          table: false,
          history: false,
          quality: false,
          fix: false
        },
  
        // 模拟导入历史数据
        importHistory: [
          {
            id: "IMP24050001",
            importType: "HIS",
            diseaseType: "lung",
            dataCount: 156,
            startTime: "2024-05-10 10:23:45",
            endTime: "2024-05-10 10:25:12",
            status: "success",
            progress: 100,
            errorRate: 2.5
          },
          {
            id: "IMP24050002",
            importType: "Manual",
            diseaseType: "prostate",
            dataCount: 83,
            startTime: "2024-05-10 14:36:28",
            endTime: "2024-05-10 14:37:05",
            status: "success",
            progress: 100,
            errorRate: 1.2
          },
          {
            id: "IMP24050003",
            importType: "HIS",
            diseaseType: "lung",
            dataCount: 204,
            startTime: "2024-05-11 09:15:32",
            endTime: null,
            status: "processing",
            progress: 65,
            errorRate: 3.8
          },
          {
            id: "IMP24050004",
            importType: "HIS",
            diseaseType: "prostate",
            dataCount: 92,
            startTime: "2024-05-09 16:44:21",
            endTime: "2024-05-09 16:46:03",
            status: "partial",
            progress: 86,
            errorRate: 6.5
          },
          {
            id: "IMP24050005",
            importType: "Manual",
            diseaseType: "lung",
            dataCount: 48,
            startTime: "2024-05-08 11:20:18",
            endTime: "2024-05-08 11:20:55",
            status: "failed",
            progress: 32,
            errorRate: 15.2
          }
        ],
  
        // 模拟患者列表数据
        patientList: [],
  
        // 模拟数据质量列表
        dataQualityList: [],
  
        // 帮助数据
        helpData: {
          issueTypes: [
            {
              type: "数据缺失",
              description: "必要的字段数据缺失，如患者基本信息、诊断信息等",
              solution: "补充相关数据，或从其他系统导入"
            },
            {
              type: "数据异常",
              description: "数据值明显超出正常范围或与临床实际不符",
              solution: "核对原始记录，修正错误数据"
            },
            {
              type: "格式不一致",
              description: "数据格式不符合系统要求，如日期格式、编码格式等",
              solution: "按系统要求格式修改，或使用系统提供的转换功能"
            },
            {
              type: "数据冲突",
              description: "同一患者的不同记录之间存在明显矛盾",
              solution: "核对所有相关记录，确定正确数据并更新"
            },
            {
              type: "重复数据",
              description: "系统中存在重复的患者记录或检查记录",
              solution: "合并重复记录或删除多余记录"
            }
          ]
        }
      };
    },
    created() {
      this.getPatientList();
      this.getDataQualityList();
    },
    methods: {
      // 从HIS导入数据
      importFromHIS() {
        if (!this.hisStatus.connected) {
          this.$message.error("HIS系统连接异常，无法导入数据");
          return;
        }
  
        this.loading.his = true;
        setTimeout(() => {
        this.loading.his = false;
        this.$message.success("已成功发起数据导入任务，您可以在导入历史中查看进度");
        // 添加一个新的导入记录
        const newImport = {
          id: "IMP" + new Date().getTime().toString().substr(-8),
          importType: "HIS",
          diseaseType: this.hisForm.diseaseType,
          dataCount: Math.floor(Math.random() * 100 + 50),
          startTime: this.formatDateTime(new Date()),
          endTime: null,
          status: "processing",
          progress: 0,
          errorRate: 0
        };
        this.importHistory.unshift(newImport);
        this.pagination.total += 1;
        
        // 模拟更新进度
        this.simulateProgressUpdate(newImport.id);
      }, 2000);
    },

    // 模拟进度更新
    simulateProgressUpdate(id) {
      const timer = setInterval(() => {
        const index = this.importHistory.findIndex(item => item.id === id);
        if (index === -1) {
          clearInterval(timer);
          return;
        }
        
        const item = this.importHistory[index];
        item.progress += Math.floor(Math.random() * 10 + 5);
        
        if (item.progress >= 100) {
          item.progress = 100;
          item.status = Math.random() > 0.8 ? 'partial' : 'success';
          item.endTime = this.formatDateTime(new Date());
          item.errorRate = (Math.random() * 5).toFixed(1);
          clearInterval(timer);
          
          // 更新统计数据
          this.statistics.total += Math.floor(item.dataCount * (100 - item.errorRate) / 100);
          this.patientData.total += Math.floor(item.dataCount * (100 - item.errorRate) / 100);
          if (item.diseaseType === 'lung') {
            this.patientData.lung += Math.floor(item.dataCount * (100 - item.errorRate) / 100);
          } else if (item.diseaseType === 'prostate') {
            this.patientData.prostate += Math.floor(item.dataCount * (100 - item.errorRate) / 100);
          }
        }
      }, 1500);
    },

    // 开始模拟进度更新
    startProgressSimulation() {
      this.importHistory.forEach(item => {
        if (item.status === 'processing') {
          this.simulateProgressUpdate(item.id);
        }
      });
    },

    // 重置HIS表单
    resetHisForm() {
      this.hisForm = {
        diseaseType: "all",
        dateRange: null,
        department: "all",
        dataTypes: ["patient", "lab", "treatment", "followup"],
        priority: "normal",
        autoAudit: true
      };
    },

    // 文件上传相关处理函数
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },

    handlePreview(file) {
      console.log(file);
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },

    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    uploadFiles() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先选择要上传的文件");
        return;
      }

      this.loading.upload = true;
      setTimeout(() => {
        this.loading.upload = false;
        this.$message.success(`成功上传 ${this.fileList.length} 个文件`);
        
        // 添加导入记录
        const newImport = {
          id: "IMP" + new Date().getTime().toString().substr(-8),
          importType: "Manual",
          diseaseType: Math.random() > 0.5 ? 'lung' : 'prostate',
          dataCount: Math.floor(Math.random() * 50 + 10) * this.fileList.length,
          startTime: this.formatDateTime(new Date()),
          endTime: null,
          status: "processing",
          progress: 0,
          errorRate: 0
        };
        this.importHistory.unshift(newImport);
        this.pagination.total += 1;
        
        // 清空文件列表
        this.fileList = [];
        
        // 模拟进度更新
        this.simulateProgressUpdate(newImport.id);
      }, 1500);
    },

    // 刷新导入历史
    refreshImportHistory() {
      this.loading.history = true;
      setTimeout(() => {
        this.loading.history = false;
        this.$message.success("导入历史已刷新");
      }, 800);
    },

    // 分页相关函数
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      // 实际应用中应该重新请求数据
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      // 实际应用中应该重新请求数据
    },

    handleDataSizeChange(val) {
      this.dataPagination.pageSize = val;
      this.getPatientList();
    },

    handleDataCurrentChange(val) {
      this.dataPagination.currentPage = val;
      this.getPatientList();
    },

    handleQualitySizeChange(val) {
      this.qualityPagination.pageSize = val;
      this.getDataQualityList();
    },

    handleQualityCurrentChange(val) {
      this.qualityPagination.currentPage = val;
      this.getDataQualityList();
    },

    handleErrorSizeChange(val) {
      this.errorDialog.pagination.pageSize = val;
      this.loadErrorData();
    },

    handleErrorCurrentChange(val) {
      this.errorDialog.pagination.currentPage = val;
      this.loadErrorData();
    },

    // 获取状态类型和文本
    getStatusType(status) {
      switch(status) {
        case 'success': return 'success';
        case 'processing': return 'primary';
        case 'partial': return 'warning';
        case 'failed': return 'danger';
        default: return 'info';
      }
    },

    getStatusText(status) {
      switch(status) {
        case 'success': return '成功';
        case 'processing': return '进行中';
        case 'partial': return '部分成功';
        case 'failed': return '失败';
        default: return '未知';
      }
    },

    getProgressStatus(status) {
      switch(status) {
        case 'success': return 'success';
        case 'processing': return '';
        case 'partial': return 'warning';
        case 'failed': return 'exception';
        default: return '';
      }
    },

    // 获取数据状态类型和文本
    getDataStatusType(status) {
      switch(status) {
        case 'valid': return 'success';
        case 'missing': return 'warning';
        case 'error': return 'danger';
        case 'pending': return 'info';
        default: return 'info';
      }
    },

    getDataStatusText(status) {
      switch(status) {
        case 'valid': return '有效';
        case 'missing': return '缺失';
        case 'error': return '异常';
        case 'pending': return '待审核';
        default: return '未知';
      }
    },

    // 获取AI状态类型和文本
    getAiStatusType(status) {
      switch(status) {
        case 'analyzed': return 'success';
        case 'pending': return 'warning';
        case 'not_ready': return 'info';
        case 'failed': return 'danger';
        default: return 'info';
      }
    },

    getAiStatusText(status) {
      switch(status) {
        case 'analyzed': return '已分析';
        case 'pending': return '待分析';
        case 'not_ready': return '未就绪';
        case 'failed': return '分析失败';
        default: return '未知';
      }
    },

    // 获取问题类型标签
    getIssueTypeTag(type) {
      switch(type) {
        case '数据缺失': return 'warning';
        case '数据异常': return 'danger';
        case '格式不一致': return 'info';
        case '数据冲突': return 'danger';
        case '重复数据': return 'warning';
        default: return 'info';
      }
    },

    // 获取完整度颜色
    getCompletenessColor(val) {
      if (val < 50) return '#F56C6C';
      if (val < 80) return '#E6A23C';
      return '#67C23A';
    },

    // 获取日志级别类型
    getLogLevelType(level) {
      switch(level) {
        case 'INFO': return 'info';
        case 'WARNING': return 'warning';
        case 'ERROR': return 'danger';
        case 'SUCCESS': return 'success';
        default: return 'info';
      }
    },

    // 格式化日期时间
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取患者列表
    getPatientList() {
      this.loading.table = true;
      
      // 模拟从服务器请求数据
      setTimeout(() => {
        const mockPatients = [];
        const total = 100; // 模拟100条数据
        
        for (let i = 0; i < total; i++) {
          const diseaseType = Math.random() > 0.5 ? 'lung' : 'prostate';
          const dataCompleteness = Math.floor(Math.random() * 100);
          let dataStatus;
          if (dataCompleteness < 50) dataStatus = 'error';
          else if (dataCompleteness < 80) dataStatus = 'missing';
          else dataStatus = 'valid';
          
          let aiStatus;
          if (dataStatus === 'valid') {
            aiStatus = Math.random() > 0.6 ? 'analyzed' : 'pending';
          } else if (dataStatus === 'missing') {
            aiStatus = Math.random() > 0.8 ? 'pending' : 'not_ready';
          } else {
            aiStatus = 'not_ready';
          }
          
          mockPatients.push({
            id: `P${i + 10000}`,
            name: this.generateName(),
            age: Math.floor(Math.random() * 40 + 40), // 40-80岁
            gender: Math.random() > 0.7 ? 'female' : 'male',
            diseaseType,
            idNumber: this.generateIdNumber(),
            stage: diseaseType === 'lung' ? this.generateLungStage() : this.generateProstateStage(),
            diagnosisDate: this.generatePastDate(),
            dataStatus,
            dataCompleteness,
            aiStatus,
            lastUpdate: this.generatePastDate(true),
            phone: this.generatePhone()
          });
        }
        
        // 过滤和分页
        const start = (this.dataPagination.currentPage - 1) * this.dataPagination.pageSize;
        const end = start + this.dataPagination.pageSize;
        
        this.patientList = mockPatients.slice(start, end);
        this.dataPagination.total = total;
        this.loading.table = false;
      }, 1000);
    },

    // 生成模拟数据的辅助函数
    generateName() {
      const surnames = ['张', '王', '李', '赵', '陈', '刘', '杨', '黄', '周', '吴', '郑', '孙', '马', '朱', '胡'];
      const names = ['明', '华', '军', '强', '伟', '杰', '磊', '勇', '艳', '娟', '芳', '敏', '静', '霞', '燕'];
      return surnames[Math.floor(Math.random() * surnames.length)] + names[Math.floor(Math.random() * names.length)];
    },
    
    generateIdNumber() {
      let id = '4401';
      for(let i = 0; i < 14; i++) {
        id += Math.floor(Math.random() * 10);
      }
      return id;
    },
    
    generatePhone() {
      let phone = '1';
      const secondDigit = Math.floor(Math.random() * 5) + 3; // 3-7
      phone += secondDigit;
      for(let i = 0; i < 9; i++) {
        phone += Math.floor(Math.random() * 10);
      }
      return phone;
    },
    
    generateLungStage() {
      const stages = ['I期', 'II期', 'III期', 'IV期'];
      return stages[Math.floor(Math.random() * stages.length)];
    },
    
    generateProstateStage() {
      const stages = ['T1期', 'T2期', 'T3期', 'T4期'];
      return stages[Math.floor(Math.random() * stages.length)];
    },
    
    generatePastDate(withTime = false) {
      const now = new Date();
      const pastDays = Math.floor(Math.random() * 365 * 2); // 过去2年内
      now.setDate(now.getDate() - pastDays);
      
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      
      if (!withTime) {
        return `${year}-${month}-${day}`;
      }
      
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 获取数据质量列表
    getDataQualityList() {
      this.loading.quality = true;
      
      // 模拟从服务器请求数据
      setTimeout(() => {
        const mockIssues = [];
        const issueTypes = ['数据缺失', '数据异常', '格式不一致', '数据冲突', '重复数据'];
        const fields = [
          '年龄', '性别', '诊断日期', '疾病分期', '病理结果', 
          'PSA值', 'CT结果', '肿瘤大小', '治疗记录', '随访记录'
        ];
        
        for (let i = 0; i < 50; i++) {
          const issueType = issueTypes[Math.floor(Math.random() * issueTypes.length)];
          const issueField = fields[Math.floor(Math.random() * fields.length)];
          
          let issueDescription = '';
          let suggestion = '';
          
          switch(issueType) {
            case '数据缺失':
              issueDescription = `${issueField}数据缺失，无法进行AI分析`;
              suggestion = `请补充患者${issueField}数据`;
              break;
            case '数据异常':
              issueDescription = `${issueField}数据值异常，超出正常范围`;
              suggestion = `请核对原始记录，确认${issueField}数据准确性`;
              break;
            case '格式不一致':
              issueDescription = `${issueField}数据格式不符合系统要求`;
              suggestion = `请将${issueField}调整为标准格式`;
              break;
            case '数据冲突':
              issueDescription = `${issueField}数据与其他记录存在冲突`;
              suggestion = `请核对相关记录，解决${issueField}数据冲突`;
              break;
            case '重复数据':
              issueDescription = `检测到${issueField}重复记录`;
              suggestion = `请合并或删除重复的${issueField}记录`;
              break;
          }
          
          mockIssues.push({
            patientId: `P${Math.floor(Math.random() * 10000 + 10000)}`,
            patientName: this.generateName(),
            diseaseType: Math.random() > 0.5 ? 'lung' : 'prostate',
            issueType,
            issueField,
            issueDescription,
            suggestion,
            status: Math.random() > 0.7 ? 'pending' : 'fixed'
          });
        }
        
        // 过滤和分页
        const start = (this.qualityPagination.currentPage - 1) * this.qualityPagination.pageSize;
        const end = start + this.qualityPagination.pageSize;
        
        this.dataQualityList = mockIssues.slice(start, end);
        this.qualityPagination.total = mockIssues.length;
        this.loading.quality = false;
      }, 1000);
    },

    // 搜索数据
    searchData() {
      this.dataPagination.currentPage = 1;
      this.getPatientList();
    },

    // 重置搜索
    resetSearch() {
      this.search = "";
      this.filterStatus = "";
      this.filterDisease = "";
      this.searchData();
    },

    // 处理选择变化
    handleSelectionChange(selection) {
      this.selection = selection;
    },

    // 查看患者详情
    viewPatientDetail(patient) {
      this.patientDetailDialog.visible = true;
      this.patientDetailDialog.patient = patient;
      this.patientDetailDialog.activeTab = 'basic';
      
      // 模拟加载患者详情数据
      this.loadPatientDetailData(patient.id);
    },

    // 加载患者详情数据
    loadPatientDetailData(patientId) {
      // 模拟临床检查数据
      this.patientDetailDialog.clinicalTests = this.generateClinicalTests(patientId);
      
      // 模拟治疗记录
      this.patientDetailDialog.treatments = this.generateTreatments(patientId);
      
      // 模拟随访记录
      this.patientDetailDialog.followups = this.generateFollowups(patientId);
      
      // 模拟数据问题
      this.patientDetailDialog.dataIssues = this.generateDataIssues(patientId);
    },

    // 生成模拟临床检查数据
    generateClinicalTests(patientId) {
      const tests = [];
      const testTypes = ['CT检查', '核磁共振', '血液检验', 'PET-CT', '病理活检', '超声检查'];
      const count = Math.floor(Math.random() * 6) + 2; // 2-7条记录
      
      for (let i = 0; i < count; i++) {
        const testType = testTypes[Math.floor(Math.random() * testTypes.length)];
        let testName = '';
        let result = '';
        let conclusion = '';
        
        switch(testType) {
          case 'CT检查':
            testName = '胸部CT';
            result = Math.random() > 0.7 
              ? '右肺上叶见一不规则结节影，大小约15mm×12mm，密度不均，边界模糊' 
              : '双肺野清晰，未见明显异常密度影';
            conclusion = Math.random() > 0.7 ? '考虑恶性肿瘤可能' : '未见明显异常';
            break;
          case '核磁共振':
            testName = '盆腔MRI';
            result = Math.random() > 0.6 
              ? '前列腺增大，右侧周边带见异常信号影，大小约1.8×1.5cm' 
              : '前列腺大小正常，未见异常信号';
            conclusion = Math.random() > 0.6 ? '考虑前列腺癌可能，建议进一步检查' : '未见明显异常';
            break;
          case '血液检验':
            testName = Math.random() > 0.5 ? 'PSA检测' : '肿瘤标志物';
            result = Math.random() > 0.6 ? 'PSA: 15.8ng/ml，fPSA: 1.2ng/ml，fPSA/PSA: 7.6%' : 'PSA: 3.2ng/ml，fPSA: 0.8ng/ml，fPSA/PSA: 25%';
            conclusion = Math.random() > 0.6 ? 'PSA明显升高，建议前列腺穿刺活检' : 'PSA在正常范围内';
            break;
          case 'PET-CT':
            testName = '全身PET-CT';
            result = Math.random() > 0.7 
              ? '右肺上叶见一高代谢结节，SUVmax=8.6，大小约16×14mm，考虑恶性肿瘤可能' 
              : '全身未见明显异常高代谢灶';
            conclusion = Math.random() > 0.7 ? '考虑肺癌可能，建议进一步检查' : '未见明显异常';
            break;
          case '病理活检':
            testName = Math.random() > 0.5 ? '肺穿刺活检' : '前列腺穿刺活检';
            result = Math.random() > 0.8 
              ? '腺癌，Gleason评分7分(3+4)' 
              : '未见明确恶性细胞';
            conclusion = Math.random() > 0.8 ? '符合恶性肿瘤' : '未见明确恶性病变';
            break;
          case '超声检查':
            testName = '前列腺超声';
            result = Math.random() > 0.6 
              ? '前列腺增大，大小5.2×4.8×4.5cm，右侧周边区见低回声区，边界不清，CDFI示内部血流信号丰富' 
              : '前列腺大小4.3×3.8×3.5cm，形态规则，回声均匀';
            conclusion = Math.random() > 0.6 ? '前列腺增大，考虑前列腺癌可能' : '前列腺轻度增大，考虑良性前列腺增生';
            break;
        }
        
        tests.push({
          testDate: this.generatePastDate(),
          testType,
          testName,
          result,
          conclusion
        });
      }
      
      return tests;
    },

    // 生成模拟治疗记录
    generateTreatments(patientId) {
      const treatments = [];
      const treatmentTypes = ['手术', '放疗', '化疗', '靶向治疗', '免疫治疗', '内分泌治疗'];
      const count = Math.floor(Math.random() * 5) + 1; // 1-5条记录
      
      for (let i = 0; i < count; i++) {
        const treatmentType = treatmentTypes[Math.floor(Math.random() * treatmentTypes.length)];
        let treatmentName = '';
        let details = '';
        let response = '';
        let sideEffects = '';
        
        switch(treatmentType) {
          case '手术':
            treatmentName = Math.random() > 0.5 ? '肺叶切除术' : '前列腺根治术';
            details = Math.random() > 0.5 
              ? '全麻下行胸腔镜辅助右肺上叶切除术+系统性纵隔淋巴结清扫术' 
              : '全麻下行腹腔镜辅助前列腺根治术';
            response = Math.random() > 0.8 ? '手术顺利，术后恢复良好' : '手术顺利，术后恢复一般';
            sideEffects = Math.random() > 0.7 ? '无明显不良反应' : '术后切口轻度感染，经处理后好转';
            break;
          case '放疗':
            treatmentName = '立体定向放疗';
            details = '采用IMRT技术，总剂量60Gy/30次，每日2Gy，治疗时间6周';
            response = Math.random() > 0.7 ? '肿瘤明显缩小，疗效良好' : '肿瘤轻度缩小，疗效一般';
            sideEffects = Math.random() > 0.6 ? '轻度放射性肺炎，经治疗后好转' : '轻度放射性皮炎，未予特殊处理';
            break;
          case '化疗':
            treatmentName = Math.random() > 0.5 ? 'GP方案' : 'TP方案';
            details = '吉西他滨1000mg/m²，d1,8；顺铂75mg/m²，d1，21天为一个周期，共4个周期';
            response = Math.random() > 0.7 ? 'PR(部分缓解)' : 'SD(疾病稳定)';
            sideEffects = '骨髓抑制、恶心呕吐，经对症处理后缓解';
            break;
          case '靶向治疗':
            treatmentName = Math.random() > 0.5 ? '奥希替尼' : '阿法替尼';
            details = '口服奥希替尼80mg，每日1次';
            response = Math.random() > 0.8 ? 'PR(部分缓解)' : 'SD(疾病稳定)';
            sideEffects = Math.random() > 0.6 ? '轻度皮疹、腹泻，经对症处理后好转' : '无明显不良反应';
            break;
          case '免疫治疗':
            treatmentName = Math.random() > 0.5 ? '帕博利珠单抗' : '纳武利尤单抗';
            details = '静脉输注帕博利珠单抗200mg，每3周1次';
            response = Math.random() > 0.7 ? 'PR(部分缓解)' : 'SD(疾病稳定)';
            sideEffects = Math.random() > 0.7 ? '轻度免疫相关性甲状腺功能减退，给予甲状腺素替代治疗' : '无明显不良反应';
            break;
          case '内分泌治疗':
            treatmentName = Math.random() > 0.5 ? '比卡鲁胺' : 'LHRH激动剂';
            details = '口服比卡鲁胺50mg，每日1次';
            response = Math.random() > 0.8 ? 'PSA明显下降，疗效良好' : 'PSA轻度下降，疗效一般';
            sideEffects = Math.random() > 0.6 ? '轻度潮热、乏力' : '无明显不良反应';
            break;
        }
        
        treatments.push({
          treatmentDate: this.generatePastDate(),
          treatmentType,
          treatmentName,
          doctor: this.generateName(),
          details,
          response,
          sideEffects
        });
      }
      
      return treatments;
    },

    // 生成模拟随访记录
    generateFollowups(patientId) {
      const followups = [];
      const followupTypes = ['门诊', '电话', '视频'];
      const count = Math.floor(Math.random() * 6) + 2; // 2-7条记录
      
      for (let i = 0; i < count; i++) {
        const followupType = followupTypes[Math.floor(Math.random() * followupTypes.length)];
        
        followups.push({
          followupDate: this.generatePastDate(),
          followupType,
          attendingDoctor: this.generateName(),
          symptoms: Math.random() > 0.6 
            ? '无明显不适' 
            : '轻度乏力，食欲一般',
          physicalExam: Math.random() > 0.7 
            ? '各系统检查无明显异常' 
            : '胸部听诊呼吸音清晰，未闻及明显干湿啰音',
          assessment: Math.random() > 0.7 
            ? '疾病稳定，预后良好' 
            : '疾病控制一般，需密切监测',
          plan: '建议3个月后复查胸部CT、血常规等'
        });
      }
      
      return followups;
    },

    // 生成模拟数据问题
    generateDataIssues(patientId) {
      if (Math.random() > 0.7) return []; // 70%的患者没有数据问题
      
      const issues = [];
      const count = Math.floor(Math.random() * 3) + 1; // 1-3条问题
      const issueTypes = ['数据缺失', '数据异常', '格式不一致', '数据冲突', '重复数据'];
      const fields = [
        '年龄', '性别', '诊断日期', '疾病分期', '病理结果', 
        'PSA值', 'CT结果', '肿瘤大小', '治疗记录', '随访记录'
      ];
      
      for (let i = 0; i < count; i++) {
        const issueType = issueTypes[Math.floor(Math.random() * issueTypes.length)];
        const issueField = fields[Math.floor(Math.random() * fields.length)];
        
        let issueDescription = '';
        let suggestion = '';
        
        switch(issueType) {
          case '数据缺失':
            issueDescription = `${issueField}数据缺失，无法进行AI分析`;
            suggestion = `请补充患者${issueField}数据`;
            break;
          case '数据异常':
            issueDescription = `${issueField}数据值异常，超出正常范围`;
            suggestion = `请核对原始记录，确认${issueField}数据准确性`;
            break;
          case '格式不一致':
            issueDescription = `${issueField}数据格式不符合系统要求`;
            suggestion = `请将${issueField}调整为标准格式`;
            break;
          case '数据冲突':
            issueDescription = `${issueField}数据与其他记录存在冲突`;
            suggestion = `请核对相关记录，解决${issueField}数据冲突`;
            break;
          case '重复数据':
            issueDescription = `检测到${issueField}重复记录`;
            suggestion = `请合并或删除重复的${issueField}记录`;
            break;
        }
        
        issues.push({
          issueType,
          issueField,
          issueDescription,
          suggestion,
          status: Math.random() > 0.7 ? 'pending' : 'fixed'
        });
      }
      
      return issues;
    },

    // 编辑患者数据
    editPatientData(patient) {
      this.$message.info(`正在编辑患者 ${patient.name} 的数据，此功能尚未实现`);
      // 实际应用中应该打开编辑对话框或跳转到编辑页面
    },

    // 分析患者数据
    analyzePatient(patient) {
      this.$message.success(`已开始分析患者 ${patient.name} 的数据，分析结果将稍后生成`);
      
      // 模拟分析过程
      const index = this.patientList.findIndex(p => p.id === patient.id);
      if (index !== -1) {
        this.patientList[index].aiStatus = 'analyzed';
      }
      
      if (this.patientDetailDialog.patient && this.patientDetailDialog.patient.id === patient.id) {
        this.patientDetailDialog.patient.aiStatus = 'analyzed';
      }
    },

    // 查看导入详情
    viewImportDetail(item) {
      this.importDetailDialog.visible = true;
      this.importDetailDialog.import = item;
      
      // 模拟加载导入详情数据
      this.loadImportDetailData(item.id);
    },

    // 加载导入详情数据
    loadImportDetailData(importId) {
      // 模拟统计数据
      const item = this.importHistory.find(i => i.id === importId);
      if (item) {
        const totalCount = item.dataCount;
        const errorCount = Math.floor(totalCount * item.errorRate / 100);
        const successCount = totalCount - errorCount;
        const completeCount = Math.floor(successCount * 0.8); // 假设80%的成功导入数据是完整的
        
        this.importDetailDialog.stats = {
          success: successCount,
          error: errorCount,
          complete: completeCount
        };
      }
      
      // 模拟日志数据
      this.importDetailDialog.logs = this.generateImportLogs(importId);
    },

    // 生成导入日志
    generateImportLogs(importId) {
      const logs = [];
      const item = this.importHistory.find(i => i.id === importId);
      if (!item) return logs;
      
      // 添加开始日志
      logs.push({
        time: item.startTime,
        level: 'INFO',
        message: `开始导入任务 ${importId}，数据类型：${item.importType === 'HIS' ? 'HIS系统' : '手动上传'}，疾病类型：${item.diseaseType === 'lung' ? '肺癌' : '前列腺癌'}`
      });
      
      // 添加进度日志
      if (item.progress >= 30) {
        logs.push({
          time: this.addMinutesToDate(new Date(item.startTime), 1),
          level: 'INFO',
          message: `导入进度：30%，已处理 ${Math.floor(item.dataCount * 0.3)} 条数据`
        });
      }
      
      if (item.progress >= 60) {
        logs.push({
          time: this.addMinutesToDate(new Date(item.startTime), 2),
          level: 'INFO',
          message: `导入进度：60%，已处理 ${Math.floor(item.dataCount * 0.6)} 条数据`
        });
      }
      
      // 添加错误日志
      if (item.errorRate > 0) {
        logs.push({
          time: this.addMinutesToDate(new Date(item.startTime), Math.random() * 2 + 1),
          level: 'WARNING',
          message: `检测到 ${Math.floor(item.dataCount * item.errorRate / 100)} 条数据异常`,
          details: {
            errorCount: Math.floor(item.dataCount * item.errorRate / 100),
            errorTypes: {
              '数据缺失': Math.floor(Math.random() * 10 + 5),
              '数据异常': Math.floor(Math.random() * 8 + 3),
              '格式不一致': Math.floor(Math.random() * 5 + 2)
            }
          }
        });
      }
      
      // 添加完成日志
      if (item.status === 'success' || item.status === 'partial') {
        logs.push({
          time: item.endTime,
          level: item.status === 'success' ? 'SUCCESS' : 'WARNING',
          message: `导入任务完成，状态：${this.getStatusText(item.status)}，成功导入 ${Math.floor(item.dataCount * (100 - item.errorRate) / 100)} 条数据，异常 ${Math.floor(item.dataCount * item.errorRate / 100)} 条数据`
        });
      } else if (item.status === 'failed') {
        logs.push({
          time: item.endTime || this.addMinutesToDate(new Date(item.startTime), 3),
          level: 'ERROR',
          message: `导入任务失败，请检查数据格式或系统连接状态`,
          details: {
            errorMessage: '数据格式不符合要求，无法完成导入',
            failedAt: `${item.progress}%`,
            recommendation: '请检查数据格式，确保符合系统要求后重试'
          }
        });
      }
      
      return logs;
    },

    // 日期工具函数 - 添加分钟
    addMinutesToDate(date, minutes) {
      const newDate = new Date(date);
      newDate.setMinutes(newDate.getMinutes() + minutes);
      return this.formatDateTime(newDate);
    },

    // 删除导入记录
    deleteImport(item) {
      this.$confirm(`确定要删除导入任务 ${item.id} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.importHistory.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.importHistory.splice(index, 1);
          this.pagination.total -= 1;
          this.$message.success('删除成功');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 重试导入
    retryImport(item) {
      this.$confirm(`确定要重试导入任务 ${item.id} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.importHistory.findIndex(i => i.id === item.id);
        if (index !== -1) {
          this.importHistory[index].status = 'processing';
          this.importHistory[index].progress = 0;
          this.importHistory[index].startTime = this.formatDateTime(new Date());
          this.importHistory[index].endTime = null;
          
          this.$message.success('已重新开始导入任务');
          this.simulateProgressUpdate(item.id);
          
          // 如果当前正在查看该任务详情，更新详情
          if (this.importDetailDialog.visible && this.importDetailDialog.import && this.importDetailDialog.import.id === item.id) {
            this.importDetailDialog.import = this.importHistory[index];
            this.loadImportDetailData(item.id);
          }
        }
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 修复问题
    fixIssue(issue) {
      this.fixDialog.visible = true;
      this.fixDialog.issue = issue;
      this.fixDialog.form = {
        value: '',
        comment: ''
      };
    },

    // 跳过问题
    skipIssue(issue) {
      this.$confirm(`确定要忽略问题"${issue.issueDescription}"吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 实际应用中应该调用API更新问题状态
        issue.status = 'fixed';
        this.$message.success('已忽略此问题');
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 提交修复
    submitFix() {
      if (!this.fixDialog.form.value) {
        this.$message.warning('请输入修复后的值');
        return;
      }
      
      this.loading.fix = true;
      setTimeout(() => {
        this.loading.fix = false;
        
        // 实际应用中应该调用API更新数据
        if (this.fixDialog.issue) {
          this.fixDialog.issue.status = 'fixed';
        }
        
        this.fixDialog.visible = false;
        this.$message.success('数据修复成功');
      }, 1000);
    },

    // 查看异常详情
    handleViewErrors() {
      this.errorDialog.visible = true;
      this.loadErrorData();
    },

    // 加载错误数据
    loadErrorData() {
      // 模拟加载错误数据
      const mockErrors = [];
      const errorTypes = ['数据缺失', '数据异常', '格式不一致', '数据冲突', '重复数据'];
      const fields = [
        '年龄', '性别', '诊断日期', '疾病分期', '病理结果', 
        'PSA值', 'CT结果', '肿瘤大小', '治疗记录', '随访记录'
      ];
      
      for (let i = 0; i < 30; i++) {
        const errorType = errorTypes[Math.floor(Math.random() * errorTypes.length)];
        const errorField = fields[Math.floor(Math.random() * fields.length)];
        
        let errorValue = '';
        let errorDescription = '';
        let suggestion = '';
        
        switch(errorType) {
          case '数据缺失':
            errorValue = 'NULL';
            errorDescription = `${errorField}数据缺失，无法进行AI分析`;
            suggestion = `请补充患者${errorField}数据`;
            break;
          case '数据异常':
            errorValue = errorField === '年龄' ? '256' : errorField === 'PSA值' ? '1200' : 'Unknown';
            errorDescription = `${errorField}数据值异常，超出正常范围`;
            suggestion = `请核对原始记录，确认${errorField}数据准确性`;
            break;
          case '格式不一致':
            errorValue = errorField === '诊断日期' ? '2024/5/1' : '非标准格式';
            errorDescription = `${errorField}数据格式不符合系统要求`;
            suggestion = `请将${errorField}调整为标准格式`;
            break;
          case '数据冲突':
            errorValue = '冲突值';
            errorDescription = `${errorField}数据与其他记录存在冲突`;
            suggestion = `请核对相关记录，解决${errorField}数据冲突`;
            break;
          case '重复数据':
            errorValue = '重复记录';
            errorDescription = `检测到${errorField}重复记录`;
            suggestion = `请合并或删除重复的${errorField}记录`;
            break;
        }
        
        mockErrors.push({
          patientId: `P${Math.floor(Math.random() * 10000 + 10000)}`,
          patientName: this.generateName(),
          diseaseType: Math.random() > 0.5 ? 'lung' : 'prostate',
          errorType,
          errorField,
          errorValue,
          errorDescription,
          suggestion
        });
      }
      
      // 过滤和分页
      const start = (this.errorDialog.pagination.currentPage - 1) * this.errorDialog.pagination.pageSize;
      const end = start + this.errorDialog.pagination.pageSize;
      
      this.errorDialog.data = mockErrors.slice(start, end);
      this.errorDialog.pagination.total = mockErrors.length;
    },

    // 修复错误数据
    fixError(error) {
      this.fixDialog.visible = true;
      this.fixDialog.issue = {
        patientId: error.patientId,
        patientName: error.patientName,
        issueField: error.errorField,
        issueDescription: error.errorDescription,
        suggestion: error.suggestion
      };
      this.fixDialog.form = {
        value: '',
        comment: ''
      };
    },

    // 忽略错误数据
    ignoreError(error) {
      this.$confirm(`确定要忽略患者 ${error.patientName} 的 ${error.errorField} 错误吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.errorDialog.data.findIndex(e => e.patientId === error.patientId && e.errorField === error.errorField);
        if (index !== -1) {
          this.errorDialog.data.splice(index, 1);
          this.errorDialog.pagination.total -= 1;
          this.$message.success('已忽略此错误');
        }
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 批量修复错误
    batchFixErrors() {
      this.$confirm(`确定要批量修复所有错误吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('已启动批量修复，请稍后查看结果');
        setTimeout(() => {
          this.errorDialog.visible = false;
          this.patientData.error = 0;
          this.statistics.error = 0;
          this.$message.success('批量修复完成，所有错误已修复');
        }, 2000);
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 显示日志详情
    showLogDetails(log) {
      this.logDetailDialog.visible = true;
      this.logDetailDialog.log = log;
    },

    // 下载导入日志
    downloadImportLog() {
      this.$message.success('日志文件已开始下载');
    },

    // 批量分析
    batchAnalyze() {
      if (this.selection.length === 0) {
        this.$message.warning('请先选择要分析的患者');
        return;
      }
      
      this.$confirm(`确定要对选中的 ${this.selection.length} 名患者进行AI分析吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success(`已启动批量分析，共 ${this.selection.length} 名患者，分析结果将稍后生成`);
        
        // 模拟分析过程
        this.selection.forEach(patient => {
          const index = this.patientList.findIndex(p => p.id === patient.id);
          if (index !== -1) {
            this.patientList[index].aiStatus = 'analyzed';
          }
        });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },

    // 批量删除
    batchDelete() {
      if (this.selection.length === 0) {
        this.$message.warning('请先选择要删除的患者');
        return;
      }
      
      this.$confirm(`确定要删除选中的 ${this.selection.length} 名患者数据吗? 此操作不可恢复!`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        // 模拟删除过程
        const ids = this.selection.map(item => item.id);
        this.patientList = this.patientList.filter(item => !ids.includes(item.id));
        this.dataPagination.total -= this.selection.length;
        this.selection = [];
        
        this.$message.success(`已成功删除 ${ids.length} 名患者数据`);
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 批量导出
    batchExport() {
      if (this.selection.length === 0) {
        this.$message.warning('请先选择要导出的患者');
        return;
      }
      
      this.$message.success(`已开始导出 ${this.selection.length} 名患者数据，请稍候`);
      setTimeout(() => {
        this.$message.success('数据导出完成，文件已下载');
      }, 1500);
    }
  }
}
</script>


<style lang="scss" scoped>
.app-container {
  padding: 20px;
  
  .header-card {
    margin-bottom: 20px;
    
    .header-title {
      display: flex;
      flex-direction: column;
      
      h2 {
        margin: 0 0 10px 0;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 10px;
          color: #409EFF;
        }
      }
      
      .header-desc {
        color: #606266;
        font-size: 14px;
      }
    }
    
    .header-stat {
      display: flex;
      margin-top: 20px;
      
      .stat-item {
        flex: 1;
        text-align: center;
        padding: 10px;
        border-right: 1px solid #EBEEF5;
        
        &:last-child {
          border-right: none;
        }
        
        .stat-number {
          font-size: 24px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 5px;
          
          .stat-alert {
            margin-left: 5px;
            
            i {
              color: #F56C6C;
              font-size: 18px;
            }
          }
        }
        
        .stat-label {
          font-size: 14px;
          color: #606266;
        }
      }
    }
  }
  
  .import-card {
    margin-bottom: 20px;
    
    .his-import-container {
      padding: 10px;
    }
    
    .upload-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .el-upload {
        width: 100%;
      }
      
      .el-upload-dragger {
        width: 100%;
      }
    }
    
    .upload-actions {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      gap: 10px;
    }
    
    .upload-template {
      padding: 0 20px;
      
      h4 {
        display: flex;
        align-items: center;
        margin-top: 0;
        
        i {
          margin-right: 5px;
          color: #409EFF;
        }
      }
      
      p {
        color: #606266;
        margin-bottom: 20px;
      }
      
      .template-list {
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        
        .template-item {
          display: flex;
          align-items: center;
          padding: 15px;
          border-bottom: 1px solid #EBEEF5;
          
          &:last-child {
            border-bottom: none;
          }
          
          .template-icon {
            font-size: 24px;
            color: #909399;
            margin-right: 15px;
          }
          
          .template-info {
            flex: 1;
            
            .template-name {
              font-weight: bold;
              margin-bottom: 5px;
            }
            
            .template-desc {
              font-size: 12px;
              color: #909399;
            }
          }
        }
      }
    }
  }
  
  .status-cards {
    margin-bottom: 20px;
    
    .status-card {
      display: flex;
      align-items: center;
      padding: 10px;
      height: 100%;
      
      .status-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        
        i {
          font-size: 24px;
          color: white;
        }
      }
      
      .status-info {
        flex: 1;
        
        .status-title {
          font-size: 14px;
          color: #606266;
          margin-bottom: 5px;
        }
        
        .status-value {
          font-size: 24px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 5px;
        }
        
        .status-desc {
          font-size: 12px;
          color: #909399;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  
  .import-history-card,
  .data-management-card {
    margin-bottom: 20px;
    
    .error-rate {
      color: #F56C6C;
      font-weight: bold;
    }
    
    .pagination-container {
      margin-top: 15px;
      text-align: right;
    }
  }
  
  .data-management-card {
    .header-operations {
      display: flex;
      align-items: center;
      margin-top: 10px;
    }
    
    .table-operations {
      margin-top: 15px;
      display: flex;
      gap: 10px;
    }
  }
  
  .issue-info {
    margin-bottom: 20px;
    
    h4 {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
  
  .fix-form {
    h4 {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
  
  .patient-detail-container {
    .el-descriptions {
      margin-bottom: 20px;
    }
  }
  
  .import-detail-container {
    .el-descriptions {
      margin-bottom: 20px;
    }
    
    .stat-mini-card {
      text-align: center;
      padding: 15px;
      
      .stat-mini-title {
        font-size: 14px;
        color: #606266;
        margin-bottom: 10px;
      }
      
      .stat-mini-value {
        font-size: 24px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 5px;
      }
      
      .stat-mini-desc {
        font-size: 12px;
        color: #909399;
      }
    }
  }
  
  .log-detail {
    pre {
      background-color: #f5f7fa;
      padding: 15px;
      border-radius: 4px;
      font-size: 12px;
      line-height: 1.5;
      overflow: auto;
      max-height: 400px;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
  
  .help-content {
    h3 {
      margin-top: 20px;
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
    }
    
    p {
      color: #606266;
      line-height: 1.6;
    }
    
    ol, ul {
      color: #606266;
      padding-left: 20px;
      margin-bottom: 15px;
      
      li {
        margin-bottom: 5px;
        
        strong {
          font-weight: bold;
        }
      }
    }
    
    .el-table {
      margin-bottom: 15px;
    }
    
    .el-collapse {
      margin-bottom: 15px;
    }
  }
}
</style>